import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";
import Utils from "@teamprevent/common/utils";

import * as actions from "./actiontypes";
import * as models from "./model";
import CustomerDocumentApi from "./customerDocumentApi";

import { push } from "redux-little-router";

export type CustomerDocumentAction =
      ({ type: typeof actions.LOAD_CUSTOMERDOCUMENTS_SUCCESS } & Payload<models.CustomerDocumentListModel[]>)
    | ({ type: typeof actions.CREATE_CUSTOMERDOCUMENT_SUCCESS } & Payload<models.CustomerDocumentDetailModel>)
    | ({ type: typeof actions.LOAD_CUSTOMERDOCUMENT_DETAIL_SUCCESS } & Payload<models.CustomerDocumentDetailModel>)
    | ({ type: typeof actions.SAVE_CUSTOMERDOCUMENT_SUCCESS } & Payload<models.CustomerDocumentDetailModel>)
    | ({ type: typeof actions.DELETE_CUSTOMERDOCUMENT_SUCCESS } & Payload<any>);

export const loadCustomerDocumentsSuccess = (payload: models.CustomerDocumentListModel[]): CustomerDocumentAction => ({
    payload,
    type: actions.LOAD_CUSTOMERDOCUMENTS_SUCCESS
});

export const createCustomerDocumentSuccess = (payload: models.CustomerDocumentDetailModel): CustomerDocumentAction => ({
    payload,
    type: actions.CREATE_CUSTOMERDOCUMENT_SUCCESS
});

export const saveCustomerDocumentSuccess = (payload: models.CustomerDocumentDetailModel): CustomerDocumentAction => ({
    payload,
    type: actions.SAVE_CUSTOMERDOCUMENT_SUCCESS
});

export const deleteCustomerDocumentSuccess = (id: any): CustomerDocumentAction => ({
    payload: id,
    type: actions.DELETE_CUSTOMERDOCUMENT_SUCCESS
});

export function createCustomerDocument(customerId: string, customerDocument: models.CustomerDocumentCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(dispatch, actions.CREATE_CUSTOMERDOCUMENT, CustomerDocumentApi.create(customerId, customerDocument));
        const result = Utils.CheckResponse(response);

        if (response.success && result) {
            dispatch(createCustomerDocumentSuccess(result));
            dispatch(push(`${path}/${result.id}`));
        }
    };
}

export function saveCustomerDocument(customerId: string, customerDocument: models.CustomerDocumentEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(dispatch, actions.SAVE_CUSTOMERDOCUMENT, CustomerDocumentApi.save(customerId, customerDocument));
        const result = Utils.CheckResponse(response);

        if (response.success && result) {
            dispatch(saveCustomerDocumentSuccess(result));
            if (path !== undefined) {
                dispatch(push(`${path}/${result.id}`));
            }
        }
    };
}

export function deleteCustomerDocument(customerId: string, id: string, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteCustomerDocument", CustomerDocumentApi.delete(customerId, id));
        dispatch(deleteCustomerDocumentSuccess(id));
        dispatch(push(path));
    };
}

export function loadCustomerDocuments({ customerId }: { customerId: string }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadCustomerDocuments", CustomerDocumentApi.getAll(customerId));
        dispatch(loadCustomerDocumentsSuccess(result));
    };
}

export const loadCustomerDocumentDetailSuccess = (customerDocument: models.CustomerDocumentDetailModel) => ({
    payload: customerDocument,
    type: actions.LOAD_CUSTOMERDOCUMENT_DETAIL_SUCCESS
});

export function loadCustomerDocumentDetail({ customerId, customerDocumentId }: { customerId: string; customerDocumentId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const customerDocument = getState().customerDocuments.filter(c => c.id === customerDocumentId)[0];

        if (customerDocument === undefined
            || customerDocument.detailUpdated === undefined
            || customerDocument.detailUpdated.isBefore(customerDocument.listUpdated)) {

            const action = customerDocument === undefined ? createCustomerDocumentSuccess : loadCustomerDocumentDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadCustomerDocumentDetail", CustomerDocumentApi.detail(customerId, customerDocumentId));
            dispatch(action(result));
        }
    };
}
